module.exports = __webpack_public_path__ + "01d196b1bfb9abd04147b6263d12a5de.zip";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/textures/GoodMorningCraftv4.95.zip
 ** module id = 598
 ** module chunks = 0
 **/